import { NavLink, useLocation } from "react-router-dom";
import { Home, Sun, Users, Calendar, Mail, Award } from "lucide-react";

const BottomNav = () => {
  const location = useLocation();

  const navItems = [
    { path: "/", icon: Home, label: "Inicio" },
    { path: "/nuestro-club", icon: Users, label: "Club" },
    { path: "/eventos", icon: Calendar, label: "Eventos" },
    { path: "/reloj-solar", icon: Sun, label: "Reloj" },
    { path: "/patrocinadores", icon: Award, label: "Patrocinadores" },
    { path: "/contacto", icon: Mail, label: "Contacto" },
  ];

  return (
    <nav className="bottom-nav" data-testid="bottom-navigation">
      <div className="grid grid-cols-3 w-full px-2 py-1.5 gap-1">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;

          return (
            <NavLink
              key={item.path}
              to={item.path}
              data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
              className={`flex flex-col items-center justify-center py-1.5 px-1 rounded-xl transition-all duration-200 border ${
                isActive
                  ? "bg-[#013E7F]/10 text-[#013E7F] border-[#013E7F]/25"
                  : "text-slate-500 border-transparent hover:bg-slate-100 hover:text-[#013E7F]"
              }`}
            >
              <Icon
                size={16}
                strokeWidth={isActive ? 2.5 : 2}
                className={`mb-0.5 transition-transform duration-200 ${isActive ? "scale-110" : ""}`}
              />
              <span className={`text-[8px] font-heading uppercase tracking-wide leading-tight text-center w-full truncate px-0.5 ${
                isActive ? "font-semibold" : "font-medium"
              }`}>
                {item.label}
              </span>
              <span className={`block w-3 h-0.5 rounded-full mt-0.5 ${isActive ? "bg-[#F7A81B]" : "bg-transparent"}`} />
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
